<template>
  <div id="app">
    <transition :name="transitionName">
        <component :is="layout">
            <router-view v-if="isRouterAlive"/>
        </component>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  watch: {// 使用watch 监听$router的变化
    $route (to, from) {
      // this.transitionName = 'animation'
      // // 如果to索引大于from索引,判断为前进状态,反之则为后退状态
      // if (to.meta.index > from.meta.index) {
      //   this.transitionName = 'slide-left'
      //
      // } else {
      //   this.transitionName = 'slide-right'
      // }
    }
  },
  data () {
    return {
      default_layout: 'member', // 设置layout
      isRouterAlive: true,
      transitionName: 'animation'
    }
  },
  computed: {
    layout () {
      return (this.$route.meta.layout || this.default_layout) + '-layout'
    }
  },
  methods: {
    // 通过声明reload方法，控制router-view的显示或隐藏，从而控制页面的再次加载
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style lang="less">
#app{
  position: absolute;
  top:0rem;
  bottom:0;
  left:0;right:0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue